import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import './Search.scss.js';
import { classnames } from '../../../utils/classnames.js';
import { useDebounce } from '../../../hooks/useDebounce.js';
import AllSearch from '../../../assets/icons/resultDir/AllSearch.js';
import AllClose from '../../../assets/icons/resultDir/AllClose.js';

var Search = /*#__PURE__*/React__default.forwardRef(function (_a, ref) {
  // -------------------------------------------------------------------------------------------------------------------
  var onClear = _a.onClear,
      _a$showClear = _a.showClear,
      showClear = _a$showClear === void 0 ? true : _a$showClear,
      _a$debounce = _a.debounce,
      debounce = _a$debounce === void 0 ? 500 : _a$debounce,
      endAdornment = _a.endAdornment,
      _a$onDebounce = _a.onDebounce,
      onDebounce = _a$onDebounce === void 0 ? function () {} : _a$onDebounce,
      pattern = _a.pattern,
      _a$isCardFilter = _a.isCardFilter,
      isCardFilter = _a$isCardFilter === void 0 ? false : _a$isCardFilter,
      props = __rest(_a, ["onClear", "showClear", "debounce", "endAdornment", "onDebounce", "pattern", "isCardFilter"]);

  var _useState = useState(props.value ? props.value.toString() : ''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1]; // Регулярное выражение для проверки ввода


  var regexp = useMemo(function () {
    if (pattern) {
      return new RegExp(pattern);
    }

    return null;
  }, [pattern]); // =======================

  useDebounce(value, debounce, function (v) {
    if (onDebounce) {
      onDebounce({
        debounceString: v.toString()
      });
    }
  });
  useEffect(function () {
    setValue(props.value ? props.value.toString() : '');
  }, [props.value]); // -------------------------------------------------------------------------------------------------------------------

  var onChangeHandler = function onChangeHandler(e) {
    if (regexp && !regexp.test(e.target.value)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    setValue(e.target.value);
    props.onChange && props.onChange(e);
  };

  var onClearClickHandler = function onClearClickHandler(e) {
    e.preventDefault();
    setValue('');
    onClear && onClear();
    onDebounce && onDebounce({
      debounceString: ''
    });
  }; // -------------------------------------------------------------------------------------------------------------------


  return /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-search', isCardFilter && 'rf-search-hcf'),
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("input", _extends({}, props, {
    ref: ref,
    type: "text",
    className: classnames(endAdornment ? 'rf-search__input-endAdornment' : 'rf-search__input'),
    placeholder: props.placeholder || 'Поиск',
    value: value,
    "data-testid": "search-test-id",
    onChange: onChangeHandler,
    pattern: pattern,
    "data-v-6e52f9c7": ""
  })), /*#__PURE__*/React__default.createElement(AllSearch, {
    className: "rf-search__search-icon",
    "data-v-6e52f9c7": ""
  }), value.length > 0 && showClear && /*#__PURE__*/React__default.createElement(AllClose, {
    "data-testid": "search-clear-test-id",
    className: classnames('rf-search__close-icon', !!endAdornment && 'rf-search__close-withEndAdornment'),
    onMouseDown: onClearClickHandler,
    "data-v-6e52f9c7": ""
  }), endAdornment && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-search__endAdornment",
    "data-v-6e52f9c7": ""
  }, endAdornment));
});

export { Search as default };
